import axios from "axios"

export const deleteRulesByIds = async (ids: number[]): Promise<void> => {
    const response = await axios.post('/booking/rule/delete-by-ids', {
        ids
    });
    return response.data;
};